import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import TopBar from '../components/layout/TopBar.svelte';
import SessionCard from '../components/session/SessionCard.svelte';
import EmptyState from '../components/shared/EmptyState.svelte';
import IconButton from '../components/shared/IconButton.svelte';
import QuickLog from '../components/session/QuickLog.svelte';
import { getRecentSessions } from '../lib/services/session';
import { getActiveChild } from '../lib/stores/children.svelte.ts';
import { formatDate, isSameDay } from '../lib/utils/time';

var root_2 = $.from_svg(`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 5v14M5 12h14"></path></svg>`);
var root_5 = $.from_html(`<div class="day-group svelte-1uq1il34667k4"><h3 class="day-header svelte-1uq1il34667k4"> </h3> <div class="day-sessions svelte-1uq1il34667k4"></div></div>`);
var root = $.from_html(`<!> <div class="history-page svelte-1uq1il34667k4"><!></div> <!>`, 1);

function History($$anchor, $$props) {
	$.push($$props, true);

	const activeChild = $.derived(getActiveChild);
	let sessions = $.state($.proxy([]));
	let showQuickLog = $.state(false);

	$.user_effect(() => {
		if (!$.get(activeChild)) return;

		loadSessions();
	});

	async function loadSessions() {
		if (!$.get(activeChild)) return;

		$.set(sessions, await getRecentSessions($.get(activeChild).id, 100), true);
	}

	const grouped = $.derived(() => () => {
		const groups = [];

		for (const session of $.get(sessions)) {
			const existing = groups.find((g) => isSameDay(g.date, session.startTime));

			if (existing) {
				existing.sessions.push(session);
			} else {
				groups.push({
					date: session.startTime,
					label: formatDate(session.startTime),
					sessions: [session]
				});
			}
		}

		return groups;
	});

	var fragment = root();
	var node = $.first_child(fragment);

	TopBar(node, {
		title: 'History',
		showBack: true,
		backPath: '/',
		children: ($$anchor, $$slotProps) => {
			var fragment_1 = $.comment();
			var node_1 = $.first_child(fragment_1);

			IconButton(node_1, {
				label: 'Log past session',
				onclick: () => $.set(showQuickLog, true),
				children: ($$anchor, $$slotProps) => {
					var svg = root_2();

					$.append($$anchor, svg);
				},
				$$slots: { default: true }
			});

			$.append($$anchor, fragment_1);
		},
		$$slots: { default: true }
	});

	var div = $.sibling(node, 2);
	var node_2 = $.child(div);

	{
		var consequent = ($$anchor) => {
			var fragment_2 = $.comment();
			var node_3 = $.first_child(fragment_2);

			EmptyState(node_3, {
				title: 'No sessions yet',
				description: 'Your feeding history will appear here'
			});

			$.append($$anchor, fragment_2);
		};

		var alternate = ($$anchor) => {
			var fragment_3 = $.comment();
			var node_4 = $.first_child(fragment_3);

			$.each(node_4, 17, () => $.get(grouped)(), $.index, ($$anchor, group) => {
				var div_1 = root_5();
				var h3 = $.child(div_1);
				var text = $.child(h3, true);

				$.reset(h3);

				var div_2 = $.sibling(h3, 2);

				$.each(div_2, 21, () => $.get(group).sessions, (session) => session.id, ($$anchor, session) => {
					var fragment_4 = $.comment();
					var node_5 = $.first_child(fragment_4);

					SessionCard(node_5, {
						get session() {
							return $.get(session);
						}
					});

					$.append($$anchor, fragment_4);
				});

				$.reset(div_2);
				$.reset(div_1);
				$.template_effect(() => $.set_text(text, $.get(group).label));
				$.append($$anchor, div_1);
			});

			$.append($$anchor, fragment_3);
		};

		$.if(node_2, ($$render) => {
			if ($.get(sessions).length === 0) $$render(consequent); else $$render(alternate, -1);
		});
	}

	$.reset(div);

	var node_6 = $.sibling(div, 2);

	QuickLog(node_6, {
		get open() {
			return $.get(showQuickLog);
		},
		onclose: () => $.set(showQuickLog, false),
		onsaved: loadSessions
	});

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	History = $.hmr(History);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-1uq1il34667k4');
		History[$.HMR].update(module.default);
	});
}

export default History;
import "bun-svelte:History.svelte-2ca3hwnszzw8m-style.css";